module.exports = __webpack_public_path__ + "img/setup2.834bb975.png";